export const MAX_DISPLAY_WIDTH = 550
export const DEFAULT_VIEWPORT_WIDTH = 375 // 设计稿的宽度，未进行vw缩放前默认的设备宽度。
